<template>
  <v-app id="403">
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <div class="mr-3 hidden-sm-and-down">
          <img src="/static/error/403.svg" alt="" />
        </div>
        <div class="text-md-center">
          <h1>403</h1>
          <h2 class="my-3 headline">{{ $t('common.acceso_denegado') }}</h2>

          <v-card-actions>
            <v-btn
              color="primary"
              prepend-icon="mdi-home"
              @click="goToDashboard"
            >
              {{ $t('permissions.dashboard') }}
            </v-btn>

            <v-btn
              variant="outlined"
              prepend-icon="mdi-arrow-left"
              @click="goBack"
            >
              {{ $t('common.volver_atras') }}
            </v-btn>
          </v-card-actions>
        </div>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
export default {
  methods: {
    goToDashboard() {
      this.$router.push({ name: 'Dashboard' });
    },

    goBack() {
      this.$router.go(-1);
    }
  },
};
</script>
<style scoped lang="css">
h1 {
  font-size: 150px;
  line-height: 150px;
  font-weight: 700;
  color: #252932;
  text-shadow: rgba(61, 61, 61, 0.3) 1px 1px, rgba(61, 61, 61, 0.2) 2px 2px, rgba(61, 61, 61, 0.3) 3px 3px;
}
</style>
